module.exports = __webpack_public_path__ + "static/income-percentage-0fc59518f883b4004bd006ec1e26e93f.svg";